import { prefersReducedMotion } from './prefersReducedMotion.js';

/**
 * Duplicates the track's children in-place for a seamless loop, then animates
 * an infinite x-translate. `data-speed` (seconds per full loop) on the
 * `x-data` host sets the pace. Hover pauses.
 */
export default () => ({
  init() {
    if (prefersReducedMotion()) return;

    const track = this.$el.querySelector('[data-marquee-track]');
    if (!track) return;

    const originals = Array.from(track.children);
    if (!originals.length) return;

    originals.forEach((child) => {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    const speed = parseFloat(this.$el.dataset.speed) || 40;

    const tween = window.gsap.to(track, {
      xPercent: -50,
      ease: 'none',
      duration: speed,
      repeat: -1,
    });

    this.$el.addEventListener('mouseenter', () => tween.timeScale(0));
    this.$el.addEventListener('mouseleave', () => tween.timeScale(1));
  },
});
